import { tableNodes } from 'prosemirror-tables-contently';

const nodes = tableNodes({
    tableGroup: 'block',
    cellContent: 'block+',
    cellAttributes: {
      // TODO: remove this unnecessary code eventually
      background: {
        default: null,
        getFromDOM(dom) {
          const htmlDom = dom;
          return htmlDom.style.backgroundColor || null;
        },
        setDOMAttr(value, attrs) {
          if (value) attrs.style = (attrs.style || '') + `background-color: ${value};`;
        },
      },
    },
  });

export default nodes;
  



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/tableNodes.js